import { useJSONFetcher, JSONFetcherOptions } from "@outplayed/json-fetcher";
import { useUGGApiVersions } from "../ugg-api-versions";
import { useValidateQueryParams } from "@ugg/shared/query-params/params-helpers";
import { validParams } from "@ugg/shared/query-params/valid-params";
import { getApiRoot } from "@ugg/shared/api/api-helpers";
import { CHAMPION_PAGES } from "@ugg/shared/pages/champion-pages";
import { cleanAdvBuildsData } from "@ugg/shared/api/data-parser/champions/adv-builds";
import { AdvBuild } from "@ugg/shared/interfaces/champions/adv-builds.interface";

function useChampionRecBuildURL(championId: number, options: { queueType?: string; patch?: string }) {
  const { queueType, patch } = options;
  const { data: version } = useUGGApiVersions({ apiKey: "builds", patch });
  const root = getApiRoot(patch);

  return [`${root}/builds`, patch, queueType, championId, `${version}.json`].join("/");
}

type RecBuildPage = CHAMPION_PAGES.ITEM_PATHS | CHAMPION_PAGES.SPELLS_ABILITIES | CHAMPION_PAGES.RUNE_SETS;

export function useChampionRecBuild(
  championId: number,
  page: RecBuildPage,
  options?: { params?: Record<string, any> } & JSONFetcherOptions<AdvBuild, ReturnType<typeof cleanAdvBuildsData>>,
) {
  const { params = {}, ssr = false, skip = false } = options || {};
  const validateQueryParams = useValidateQueryParams(validParams);
  const validatedQueryParams = validateQueryParams(page, params, true);

  const championRecBuildURL = useChampionRecBuildURL(championId, validatedQueryParams);
  return useJSONFetcher<AdvBuild, ReturnType<typeof cleanAdvBuildsData>>(championRecBuildURL, {
    ssr,
    skip,
    onCompleted: (url, json) => cleanAdvBuildsData(json),
  });
}
